<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PostSaleStatusDetailSection from './PostSaleStatusDetailSection.vue';
import { first, isEnabled, payloadOf } from './postSaleStatusDetailPresenter';

const props = defineProps({ event: { type: Object, required: true } });
const { t } = useI18n();
const items = computed(() => {
  const payload = payloadOf(props.event);
  const documents = first(payload.banco_documentos || payload.check_banco);
  const labels = [
    isEnabled(documents.doc_vendedor) && t('POST_SALE.FORM.DOC_VENDEDOR'),
    isEnabled(documents.doc_comprador) && t('POST_SALE.FORM.DOC_COMPRADOR'),
    isEnabled(documents.doc_imovel) && t('POST_SALE.FORM.DOC_IMOVEL'),
  ].filter(Boolean);

  return [
    {
      label: t('POST_SALE.STATUS_DETAILS.DOCUMENTS'),
      value: labels.join(', ') || t('POST_SALE.COMMON.EMPTY_VALUE'),
    },
  ];
});
</script>

<template>
  <PostSaleStatusDetailSection
    :title="t('POST_SALE.STATUS_DETAILS.CORRECT_DOCUMENTS')"
    :items="items"
  />
</template>
